import { Directive, Input, TemplateRef, ViewContainerRef, effect } from '@angular/core';
import { AuthSignalService } from '../../core/state/auth.signal';

/**
 * Muestra el elemento solo si el usuario tiene el/los permiso(s) indicados.
 * Reactivo: si cambia la sesión/permisos, se re-evalúa solo.
 *
 *   <button *appHasPermission="'campaigns.start'"> Iniciar </button>
 *   <div *appHasPermission="['teams.edit','teams.manage_members']"> ... </div>          (any por defecto)
 *   <div *appHasPermission="['a','b']" appHasPermissionMode="all"> ... </div>
 *
 * El SUPERADMIN siempre pasa (lo resuelve AuthSignalService).
 */
@Directive({ selector: '[appHasPermission]', standalone: false })
export class HasPermissionDirective {
  private perms: string[] = [];
  private mode: 'any' | 'all' = 'any';
  private shown = false;

  constructor(
    private tpl: TemplateRef<unknown>,
    private vcr: ViewContainerRef,
    private auth: AuthSignalService,
  ) {
    // Re-evalúa cuando cambian los permisos del usuario (signal).
    effect(() => this.render(this.evaluate()));
  }

  @Input() set appHasPermission(value: string | string[] | null | undefined) {
    this.perms = value == null ? [] : Array.isArray(value) ? value : [value];
    this.render(this.evaluate());
  }

  @Input() set appHasPermissionMode(mode: 'any' | 'all') {
    this.mode = mode || 'any';
    this.render(this.evaluate());
  }

  private evaluate(): boolean {
    if (this.perms.length === 0) {
      this.auth.user(); // establece dependencia del effect aunque no haya permisos
      return true;
    }
    return this.mode === 'all' ? this.auth.hasAll(...this.perms) : this.auth.hasAny(...this.perms);
  }

  private render(allowed: boolean) {
    if (allowed && !this.shown) {
      this.vcr.createEmbeddedView(this.tpl);
      this.shown = true;
    } else if (!allowed && this.shown) {
      this.vcr.clear();
      this.shown = false;
    }
  }
}
